import React, { forwardRef, HTMLAttributes } from 'react'
import styled from 'styled-components'

export const DropdownMenu = styled.ul`
    background-color: ${({ theme }) => theme.brandColors.CA_White};
    border: 1px solid ${({ theme }) => theme.brandColors.CA_Light_Gray};
    position: fixed;
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme.boxShadow};
    z-index: 30;
    padding: 2rem;
    margin: unset;
    max-height: calc(100vh - 18rem);
    overflow: auto;
`

const SMenu = styled(DropdownMenu)`
    list-style: none;
    padding: unset;
    max-height: 0;
    top: calc(100% + 2px);
    visibility: hidden;
    transition: max-height 0.3s ease;
    overflow: hidden;

    &.open {
        visibility: visible;
        max-height: 70%;
    }
`

const Menu = forwardRef<HTMLAttributes<HTMLUListElement>>(({ children, ...props }, ref) => {
    return (
        <SMenu ref={ref} {...props}>
            {children}
        </SMenu>
    )
})

export default Menu
